import React from 'react';
import { NeuroMessage } from '@ignitesales/neuro-application';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui';

const UnsupportedBrowserModal = ({ active, onClose }) => {
  const onCloseClick = () => {
    onClose();
  };

  const title = <>
    <i className="ion-alert-circled"/> <NeuroMessage id="unsupportedBrowser.title" />
  </>;

  return <Modal
    show={ active }
    className="unsupportedBrowser"
    title={ title }
    onClose={ onCloseClick }
    nodeId="root"
    closeBtn={ <i className="ion-ios-close"/> }
  >
    <img src="/classpath/assets/images/logo-edge.svg" />
    <NeuroMessage id="unsupportedBrowser.message" />
  </Modal>;
};

export default UnsupportedBrowserModal;
